<template>
  <div class="wrap">
    <div class="items">
      <div v-for="(item,i) in items" :key="i" :class="`item ${item.id==selItemId?'item-active':''}`"
           @click="()=>{selItemId=item.id;selItem=item;}">
        <div class="name">{{ item.mname }}</div>
        <div class="price">￥{{ item.mprice }}</div>
      </div>
    </div>

    <div class="qy">
      <div class="title">VIP专属权益 | 助你变强大</div>

      <div class="list">
        <div class="item">
          <img class="img" src="../../assets/images/qy1.png" alt="">
          <div class="text">当月课程 免费尝鲜</div>
        </div>
        <div class="item">
          <img class="img" src="../../assets/images/qy2.png" alt="">
          <div class="text">600门好课 免费畅学</div>
        </div>
        <div class="item">
          <img class="img" src="../../assets/images/qy3.png" alt="">
          <div class="text">享有会员 优惠权益</div>
        </div>
        <div class="item">
          <img class="img" src="../../assets/images/qy4.png" alt="">
          <div class="text">专家坐席 贴心服务</div>
        </div>
        <div class="item">
          <img class="img" src="../../assets/images/qy5.png" alt="">
          <div class="text">会员尊贵 标识</div>
        </div>
      </div>
    </div>

    <div class="title">优质系列课程 | 会员免费</div>

    <div class="spList">
      <div class="item" v-for="(item,i) in videos" @click="toDetails(item.vId)">
        <img class="img"
             :src="item.vPicUrl"
             alt
             v-if="item.vPicUrl"/>
        <img class="img"
             :src="item.vViewUrl+'?x-oss-process=video/snapshot,t_5000,f_jpg,w_800,h_600,m_fast'"
             alt
             v-else/>

        <div class="info">
          <div class="tit">{{ item.vTitle }}</div>
          <div class="other">
            <div class="left">
              <div class="cate">{{ item.vSpeaker }}</div>
              <div class="join">{{ item.vViewCount }}人已参会</div>
            </div>
            <div class="right">
              ¥{{ item.vFees }}
            </div>
          </div>
        </div>
      </div>

      <div v-show="lengthv>2"  v-if="isshow" class="more" @click="more">点击查看更多</div>
    </div>

    <div class="btns">
      <div v-if="isvip" :class="`btn btn2`" @click="()=>{goKc()}">
        前往课程页面
      </div>
      <div :class="`btn ${selItemId>0?'btn-active':''}`" @click="()=>{selItemId&&buy()}">
        {{isvip?'会员续费':'立即开通'}}
      </div>
    </div>
  </div>
</template>
<script>

import {getHttp} from "../../plugin/extendFn/postHttp";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';


export default {
  data() {
    return {
      items: [],
      selItemId: 0,
      videos: [],
      selItem: {},
      page: 0,
      isvip: false,
      lengthv:0,
      isshow:true,
    };
  },
  props: {},
  filters: {},
  methods: {
    login () {
      loginService.login(this.$router)
      .then(loginUser=>{
        
      })
    },
    async buy() {
      let wxuser = await loginService.getLoginUser();
      if (!wxuser) {
        this.login()
        return;
      }
      this.wxuser = wxuser;

      this.curPrice = this.selItem.mprice;
      this.subscribe(this.selItem.id);

      console.log(wxuser)
    },
    subscribe(bid) {


      let param = {
        orderType: 5, //4 vip购买，1 视频购买，2直播购买，3专栏购买
        bId: bid,
        payPrice: this.curPrice,
        uid: this.wxuser.uId,
      };
      this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then(res => {
        if (res.data.code == 0) {
          if (this.curPrice <= 0) {
            this.buyed = true
            this.videoData.buyed = true
            this.$toast.success('购买成功')
            return
          }
          const pay_params = JSON.parse(res.data.parMap);
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            this.onBridgeReady(pay_params);
          }
        } else if (res.data.code == 2) {
          this.toast('购买成功')
        } else {
          this.confirm('授权失败，点击确定微信授权', '取消', '确定', () => {
            return true
          }, () => {
            this.wxlogin()
            return true;
          })
        }
      });
    },
    onBridgeReady(params) {
      var that = this;
      WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: params.appId, //公众号名称，由商户传入
            timeStamp: params.timeStamp + '', //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: params.nonceStr, //支付签名随机串，不长于 32 位
            package: params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: "MD5", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: params.sign //支付签名
          },
          function (res) {
            if (res.err_msg === "get_brand_wcpay_request:ok") {

              that.$router.push({
                name: "payOk"
              });
              //that.$router.push({ path: "/myOrder" });
            } else if (res.err_msg === "get_brand_wcpay_request:fail") {
              // this.alert("支付失败！");
            }
          }
      );
    },

    getItems() {
      console.log(this)
      getHttp(AppSetting.baseUrl + '/memberitem/queryMemberItemList').then((res) => {
        if (res.data.code == 0) {
          let data = res.data.memberItmeList;
          console.log(data)
          this.items = data;
          this.selItem = this.items[0];
          this.selItemId = this.items[0].id;
          console.log(this.selItem)
        }

      })
    },

    getVipFreeVideos(page) {
      console.log(this)
      if (page >= 1) this.page = page;
      getHttp(`/ra-app/api/video/queryVideoList?pageNo=${page == 0 ? 1 : page}&pageSize=${page == 0 ? 2 : 10}`).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.videoList;
          console.log(data)
          this.videos = page <= 1 ? data : this.videos.concat(data);
          
          this.lengthv = res.data.count;
          if(this.videos.length == this.lengthv){
            this.isshow = false;
          }
          console.log(this.lengthv)
        }

      })
    },
    more() {
      this.getVipFreeVideos(this.page + 1)
    },
    toDetails(id) {
      this.$router.push({
        name: "vDetails",
        query: {type: "video", videoId: id}
      });
    },

    goKc(){
      this.$router.replace({
        name: "Video"
      });
    }
  },
  async mounted() {
    this.getItems();
    this.getVipFreeVideos(0);

    let re_wxUser =await loginService.getLoginUser()
    document.title = (this.isvip = re_wxUser && re_wxUser.uMemberType) ? '会员续费' : '开通vip会员'
  },
  destroyed() {
    window.document.title = ''
  }
};
</script>
<style scoped lang="scss">
body, html {
}

.wrap {
  padding: .3rem;
  background-color: #f1f1f1;
}

* {
  box-sizing: border-box;
}

.items {
  display: flex;
  //justify-content: space-between;

  .item {
    background: url("../../assets/images/vip_card_bg.png") no-repeat;
    background-size: 100% 100%;

    width: 2.16rem;
    height: 1.7rem;

    flex-shrink: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-right: 0.2rem;

    .name {
      font-size: .3rem;
      font-family: SourceHanSansCN;
      font-weight: bold;
      color: #644931;
    }

    .price {
      font-size: .52rem;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #EE310D;
    }

    .price:first-letter {
      font-size: .3rem;
    }

    &-active {
      background: url("../../assets/images/vip_card_bg_sel.png") no-repeat;
      background-size: 100% 100%;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.title {
  font-size: .32rem;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #333333;

  margin: .3rem .2rem;
}

.qy {
  background: #FFFFFF;
  border-radius: .1rem;
  padding: .1rem .2rem .4rem 0;

  margin-top: .2rem;

  .list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;


      margin: .2rem .45rem;

      width: 1.2rem;

      .img {
        width: 1.1rem;
        height: 1.1rem;
      }

      .text {
        margin-top: .1rem;
        font-size: .24rem;
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        text-align: center;
      }
    }
  }
}

.spList {
  margin-bottom: 1.3rem;

  .item {
    display: flex;
    padding: .2rem;
    background-color: #ffffff;
    border-radius: .08rem;

    margin-bottom: .2rem;

    .img {
      min-width: 2.84rem;
      height: 1.6rem;
      margin-right: 0.22rem;
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;

      .tit {
        //width: 172px;
        font-size: .28rem;
        font-family: SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: .36rem;
      }

      .other {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .left {
        font-size: .22rem;
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: .28rem;
      }

      .right {
        font-size: .36rem;
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #F00000;
        line-height: .28rem;
      }
    }
  }

  .more {
    margin-top: .2rem;
    text-align: center;
    padding: .2rem;
    font-size: .28rem;
    font-family: SourceHanSansCN;
    font-weight: bold;
    color: #666666;
  }
}

.btns{
  position: fixed;
  bottom: .3rem;
  right: .3rem;
  left: .3rem;
  display: flex;
  flex: 1;
  .btn2{
    flex: 1;
    margin-right: .2rem;

    background: #FFFFFF;
    border: .01rem solid #0592EA;
    border-radius: .48rem;
    background: #ffffff !important;

    color: #0592EA !important;
  }
  .btn {
    display: flex;
    justify-content: center;
    flex: 1;
    height: 1rem;
    // background: linear-gradient(90deg, #FDC358 0%, #FADDA3 100%);
    background: #aaaaaa;
    border-radius: .48rem;

    text-align: center;
    line-height: 1rem;

    font-size: .36rem;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: #291B06;

    &-active {
      background: linear-gradient(90deg, #FDC358 0%, #FADDA3 100%);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/me/upay.vue